import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AssetsService } from '@app-assets/services/assets.service';
import { SnackBarService } from '@app-core/services/snackbar/snack-bar.service';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import {
  ExternalCameraDetail,
  InstallationMountingDetails,
  InstallationQueryParams,
  InstallationReportDetails,
  installationIssue,
} from '@app-assets/models/assets.model';
import { INSTALLATION_REPORT_EXT_CAM_HEADERS, INSTALLATION_TROUBLE_SHOOTED_ISSUES } from '@app-assets/constants/assets.constants';
import { DataService } from '@app-core/services/data/data.service';
import { MatTableDataSource } from '@angular/material/table';
@Component({
  selector: 'app-installation-report',
  templateUrl: './installation-report.component.html',
  styleUrls: ['./installation-report.component.scss'],
})
export class InstallationReportComponent implements OnInit {
  private assetId: string;
  private deviceId: string;
  private displayIssues = INSTALLATION_TROUBLE_SHOOTED_ISSUES;
  public loader: boolean = true;
  public installationData: InstallationReportDetails;
  public issues: { label: string; value: string }[];
  public roadFacingImg: InstallationMountingDetails;
  public driverFacingImg: InstallationMountingDetails;
  public externalCameraInstallationImages: InstallationMountingDetails[];

  public externalCameraDetailDisplayedColumns: string[] = [];
  public externalCameraDetailSource = new MatTableDataSource<ExternalCameraDetail>([]);

  private ngUnsubscribe: Subject<void> = new Subject<void>();
  constructor(
    private location: Location,
    private route: ActivatedRoute,
    private assetsService: AssetsService,
    private snackbarService: SnackBarService,
    public translate: TranslateService,
    public dataService: DataService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.pipe(takeUntil(this.ngUnsubscribe)).subscribe((params: InstallationQueryParams) => {
      const { assetId, deviceId } = params || {};
      this.assetId = assetId;
      this.deviceId = deviceId;
    });

    if (this.assetId && this.deviceId) {
      this.getInstallationReport();
    }
  }

  private getInstallationReport() {
    this.loader = true;
    const params = {
      assetId: this.assetId,
      deviceId: this.deviceId,
    };
    this.assetsService
      .getInstallationReport(params)
      .pipe(
        finalize(() => {
          this.loader = false;
        }),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(
        (res: InstallationReportDetails) => {
          this.installationData = res;
          const { diagnosticsReport } = res.installationDetails;
          this.getIssueDisplayName(diagnosticsReport?.issues);
          this.externalCameraInstallationImages = [];

          const externalCameras = (res?.installationDetails?.externalCameras || []).filter((cam) => cam.configured);
          if (externalCameras && externalCameras.length > 0) {
            this.externalCameraDetailDisplayedColumns = INSTALLATION_REPORT_EXT_CAM_HEADERS;
            this.externalCameraDetailSource.data = externalCameras;
          } else {
            this.externalCameraDetailDisplayedColumns = [];
            this.externalCameraDetailSource.data = [];
          }

          this.installationData.installationDetails.mountingDetails.map((val: InstallationMountingDetails) => {
            if (val.cameraType === 'road-facing') {
              this.roadFacingImg = val;
            } else if (val.cameraType === 'driver-facing') {
              this.driverFacingImg = val;
            } else {
              this.externalCameraInstallationImages.push(val);
            }
          });
        },
        (err) => {
          if (err.status === 404) {
            this.snackbarService.failure(this.translate.instant('deviceInstallationReportFailed1'));
          } else {
            this.snackbarService.failure(this.translate.instant('deviceInstallationReportFailed2'));
          }
        }
      );
  }

  public getIssueDisplayName(issues: installationIssue[]) {
    const displayIssues = issues.reduce((acc, issue) => {
      const filtered = this.displayIssues.filter((item) => item.value === issue.eventType);
      return acc.concat(filtered);
    }, []);
    this.issues = displayIssues;
  }

  public navigateBack() {
    this.location.back();
  }
}
